<template>
	<div class="notice_banner_area pc_banner">
		<!-- Banner link with full-width image -->
		<a href="#" @click.prevent="handleBannerClick" class="banner-link">
			<img :src="banner.imgPath" alt="" />
		</a>

		<!-- Control buttons container (positioned over the banner) -->
		<div class="banner_controls">
			<!-- Close button -->
			<button type="button" class="control_button close_button" @click="$emit('close')">
				<span>닫기</span>
			</button>
		</div>
	</div>
</template>

<script>
export default {
	name: "PCBanner",
	props: {
		banner: {
			type: Object,
			required: true
		}
	},
	emits: ['close', 'click', 'showEvent'],
	methods: {
		handleBannerClick() {
			console.log("PCBanner: 배너 클릭됨", this.banner);
			// banner 객체를 명시적으로 전달
			this.$emit('click', this.banner);
		},
		handleCloseClick() {
			console.log("PCBanner: 닫기 버튼 클릭됨");
			this.$emit('close');
		}
	}
};
</script>

<style scoped>
.notice_banner_area {
	position: relative;
	z-index: 100;
	width: 100%;
	background-color: #ee7528;
	overflow: hidden;
}

.banner-link {
	display: block;
	position: relative;
	width: 100%;
	z-index: 2;
}

.banner-link img {
	width: 100%;
	display: block;
}

/* Control buttons container */
.banner_controls {
	position: absolute;
	right: 150px;
	bottom: 20px;
	/* 상단 중앙에서 하단으로 변경 */
	transform: none;
	/* translateY(-50%) 제거 */
	z-index: 1004;
	display: flex;
	gap: 10px;
}

/* Common button styles */
.control_button {
	padding: 6px 15px;
	background-color: rgba(0, 0, 0, 0.5);
	color: white;
	border: none;
	border-radius: 4px;
	cursor: pointer;
	font-size: 14px;
	z-index: 1004;
	transition: background-color 0.2s;
}

/* 닫기 버튼과 이벤트 버튼 스타일 통일 */
.close_button,
.event_button {
	background-color: rgba(0, 0, 0, 0.5);
}

.close_button:hover,
.event_button:hover {
	background-color: rgba(0, 0, 0, 0.7);
}

.sr-only {
	position: absolute;
	width: 1px;
	height: 1px;
	padding: 0;
	margin: -1px;
	overflow: hidden;
	clip: rect(0, 0, 0, 0);
	white-space: nowrap;
	border: 0;
}
</style>